export default __webpack_public_path__ + "static/media/info-main-lg.6821aab9.jpg";